import React from 'react';
import { useTranslation } from 'react-i18next';
import { BILINGUAL_ENABLED } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';
import ContractAuditPage from '../pages/ContractAuditPage';

// Minimal shell for signed-out visitors on a public page. Deliberately not
// <Layout>: that loads the research list and credits, which need a session.
export default function GuestAuditShell({ onSignIn }) {
  const { t, i18n } = useTranslation();
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 20px', background: 'var(--surface)', borderBottom: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/logo-white.png" alt="TrustFlow" style={{ height: 28, background: '#1f58a4', borderRadius: 6, padding: 3 }} />
          <span style={{ fontWeight: 700, color: 'var(--text-muted)' }}>Research</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {BILINGUAL_ENABLED && <LanguageSwitcher current={i18n.language} variant="light" />}
          <button
            type="button"
            onClick={onSignIn}
            style={{ padding: '7px 14px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #29a7df, #2657a5)', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
          >
            {t('audit.signIn')}
          </button>
        </div>
      </header>
      <ContractAuditPage />
    </div>
  );
}
